import { render, staticRenderFns } from "./highlight-button.vue?vue&type=template&id=ba432314&scoped=true"
import script from "./highlight-button.vue?vue&type=script&lang=js"
export * from "./highlight-button.vue?vue&type=script&lang=js"
import style0 from "./highlight-button.vue?vue&type=style&index=0&id=ba432314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba432314",
  null
  
)

export default component.exports